import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core'
import React from 'react'
import { creditCardType } from '../../../utility/utility'
import { validate_fields, validate, validateCardNumber, isValidPostalCode } from '../Common/RegExValidate'

import { DurationUseStyles } from '../FeaturePage/personalizedTrip/personalizedTripStyles'

import { flightTextField } from '../FlightsPage/flightStyles'
import { cardTypes, countriesList, monthList } from '../FlightsPage/PaymentPage/DataBank'



export const PaymentMethodForm = ({ is_mobile, paymentInfo, setPaymentInfo }) => {


    const classesAutocomplete = flightTextField()

    const updateValue = (field, value) => {
        setPaymentInfo(prevPayment => ({
            ...prevPayment,
            [field]: value
        }));
    }

    const [stateList, setStates] = React.useState();

    const durationClass = DurationUseStyles()

    const currentYear = (new Date()).getFullYear();
    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step));
    const yearList = range(currentYear, currentYear + 10, +1);

    const validCard = validateCardNumber(paymentInfo?.card_number)
    const validPostal = isValidPostalCode(paymentInfo?.address_postal_code, paymentInfo?.country_code);

    // Enhanced validation for all mandatory fields
    const isFormValid = () => {
        const requiredFields = {
            card_holder: paymentInfo?.card_holder && paymentInfo.card_holder.trim().length > 0,
            card_number: paymentInfo?.card_number && validateCardNumber(paymentInfo.card_number),
            card_type: paymentInfo?.card_type,
            cvc_code: paymentInfo?.cvc_code && validate(paymentInfo.cvc_code, validate_fields.cvv),
            cc_exp_mo: paymentInfo?.cc_exp_mo,
            cc_exp_yr: paymentInfo?.cc_exp_yr,
            address_line_one: paymentInfo?.address_line_one && paymentInfo.address_line_one.trim().length > 0,
            country_code: paymentInfo?.country_code,
            address_city: paymentInfo?.address_city && paymentInfo.address_city.trim().length > 0,
            address_postal_code: paymentInfo?.address_postal_code && isValidPostalCode(paymentInfo.address_postal_code, paymentInfo?.country_code)
        };

        return Object.values(requiredFields).every(Boolean);
    };

    // Get validation status for individual fields
    const getFieldValidationStatus = (fieldName) => {
        const fieldValidations = {
            card_holder: paymentInfo?.card_holder && paymentInfo.card_holder.trim().length > 0,
            card_number: paymentInfo?.card_number && validateCardNumber(paymentInfo.card_number),
            card_type: paymentInfo?.card_type,
            cvc_code: paymentInfo?.cvc_code && validate(paymentInfo.cvc_code, validate_fields.cvv),
            cc_exp_mo: paymentInfo?.cc_exp_mo,
            cc_exp_yr: paymentInfo?.cc_exp_yr,
            address_line_one: paymentInfo?.address_line_one && paymentInfo.address_line_one.trim().length > 0,
            country_code: paymentInfo?.country_code,
            address_state_code: paymentInfo?.address_state_code,
            address_city: paymentInfo?.address_city && paymentInfo.address_city.trim().length > 0,
            address_postal_code: paymentInfo?.address_postal_code && isValidPostalCode(paymentInfo.address_postal_code, paymentInfo?.country_code)
        };

        return fieldValidations[fieldName] || false;
    };

    const detectCardType = (cardNumber) => {
        const value = creditCardType(cardNumber)
        if (value) {
            updateValue('card_type', value)
        }

    }
    React.useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (paymentInfo?.card_number) {
                detectCardType(paymentInfo?.card_number)
            }
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [paymentInfo?.card_number, 500]);

    // Add useEffect to handle autofill events
    // React.useEffect(() => {
    //     const handleAutofill = (event) => {
    //         const field = event.target.id;
    //         const value = event.target.value;

    //         // Map field IDs to payment object properties
    //         const fieldMapping = {
    //             'Cardholder  Name': 'card_holder',
    //             'Credit/Debit Card Number': 'card_number',
    //             'Security Code': 'cvc_code',
    //             'Billing Address 1': 'address_line_one',
    //             'Billing Address 2': 'address_line_two',
    //             'City': 'address_city',
    //             'Postal Code': 'address_postal_code'
    //         };

    //         if (fieldMapping[field]) {
    //             updateValue(fieldMapping[field], value);
    //         }
    //     };

    //     // Listen for autofill events on all form fields
    //     const formFields = document.querySelectorAll('input, select');
    //     formFields.forEach(field => {
    //         field.addEventListener('animationstart', handleAutofill);
    //         field.addEventListener('change', handleAutofill);
    //         field.addEventListener('input', handleAutofill);
    //     });

    //     return () => {
    //         formFields.forEach(field => {
    //             field.removeEventListener('animationstart', handleAutofill);
    //             field.removeEventListener('change', handleAutofill);
    //             field.removeEventListener('input', handleAutofill);
    //         });
    //     };
    // }, []);


    return (
        <div >

            <div className="row">
                <div className='col-12' style={{
                    marginTop: "20px",
                }}>

                    <div className={classesAutocomplete.root}>
                        <TextField
                            label='Cardholder Name'
                            required={true}
                            id='Cardholder  Name'
                            value={paymentInfo?.card_holder || ''}
                            onChange={(event) => updateValue('card_holder', event.target.value)}
                            error={paymentInfo?.card_holder && paymentInfo.card_holder.trim().length === 0}
                            helperText={paymentInfo?.card_holder && paymentInfo.card_holder.trim().length === 0 ? "Cardholder name is required" : ""}
                        />
                    </div>
                </div>

            </div>

            <div className="row">


                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px", paddingRight: 0
                }}>

                    <div className={classesAutocomplete.root}>
                        <TextField
                            label='Credit/Debit Card Number'
                            required={true}
                            id='Credit/Debit Card Number'
                            error={paymentInfo?.card_number?.length > 0 ? !validCard : false}
                            helperText={!validCard && paymentInfo?.card_number?.length > 0 ? "Please enter a valid credit/debit card number" : ""}
                            value={paymentInfo?.card_number || ''}
                            onChange={(event) => {
                                updateValue('card_number', event.target.value)
                                // Immediate card type detection
                                const cardType = creditCardType(event.target.value)
                                if (cardType) {
                                    updateValue('card_type', cardType)
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={is_mobile ? 'col-12' : 'col-3'} style={{
                    marginTop: "20px", paddingRight: 0
                }}>

                    <FormControl className={durationClass.formControl} style={{ width: '100%' }}>
                        <InputLabel htmlFor="Credit/Debit Card Type">
                            Credit/Debit Card Type
                        </InputLabel>
                        <Select
                            className={classesAutocomplete.root}
                            required={true}
                            value={paymentInfo?.card_type || ''}
                            onChange={(event) => {
                                const value = event.target.value;
                                updateValue('card_type', value)
                            }
                            }
                            inputProps={{
                                name: 'Type',
                                id: 'Credit/Debit Card Type',
                            }}
                        >

                            <MenuItem value="">
                                <em>{` `}</em>
                            </MenuItem>
                            {cardTypes.map((val, idx) => (
                                <MenuItem
                                    key={val?.value}
                                    value={val.value}
                                    style={{ paddingTop: 8, paddingBottom: 8 }} // Add vertical spacing
                                >
                                    {val.label}
                                </MenuItem>
                            ))}

                        </Select>
                    </FormControl>


                </div>

                <div className={is_mobile ? 'col-12' : 'col-3'} style={{
                    marginTop: "20px",
                }}>

                    <div className={classesAutocomplete.root}>
                        <TextField
                            label='Security Code'
                            required={true}
                            id='Security Code'
                            helperText={!validate(paymentInfo?.cvc_code, validate_fields.cvv) && paymentInfo?.cvc_code?.length > 0 ? "Please enter a valid ccv number" : ""}
                            error={paymentInfo?.cvc_code?.length > 0 ? !validate(paymentInfo?.cvc_code, validate_fields.cvv) : false}
                            value={paymentInfo?.cvc_code || ''}
                            onChange={(event) => updateValue('cvc_code', event.target.value)}
                        />
                    </div>
                </div>
            </div>



            <div className="row">
                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px", paddingRight: 0
                }}>
                    <FormControl className={durationClass.formControl} style={{ width: '100%' }}>
                        <InputLabel htmlFor="Expiration Month">
                            Expiration Month
                        </InputLabel>
                        <Select
                            className={classesAutocomplete.root}
                            required={true}
                            value={paymentInfo?.cc_exp_mo || ''}
                            onChange={(event) => {
                                const month = event.target.value ? Number(event.target.value) : null;
                                const padded = month < 10 ? "0" + String(month) : String(month);
                                updateValue('cc_exp_mo', event.target.value)
                                updateValue('cc_exp_mo_formatted', padded)
                            }
                            }
                            inputProps={{
                                name: 'Expiration Month',
                                id: 'Expiration Month',
                            }}
                        >

                            <MenuItem value="">
                                <em>{` `}</em>
                            </MenuItem>
                            {monthList.map((val, index) => (
                                <MenuItem
                                    key={index}
                                    value={index + 1}
                                    style={{ paddingTop: 8, paddingBottom: 8 }} // Add vertical spacing
                                >
                                    {val}
                                </MenuItem>
                            ))}



                        </Select>
                    </FormControl>

                </div>
                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px",
                }}>

                    <FormControl className={durationClass.formControl} style={{ width: '100%' }}>
                        <InputLabel htmlFor="Expiration Year">
                            Expiration Year
                        </InputLabel>
                        <Select
                            className={classesAutocomplete.root}
                            required={true}
                            value={paymentInfo?.cc_exp_yr || ''}
                            onChange={(event) => updateValue('cc_exp_yr', event.target.value)}
                            inputProps={{
                                name: 'Expiration Year',
                                id: 'Expiration Year',
                            }}
                        >
                            <MenuItem value="">
                                <em>{` `}</em>
                            </MenuItem>
                            {yearList.map((val, idx) => (
                                <MenuItem
                                    key={idx}
                                    value={val}
                                    style={{ paddingTop: 8, paddingBottom: 8 }} // Add vertical spacing
                                >
                                    {val}
                                </MenuItem>
                            ))}

                        </Select>
                    </FormControl>
                </div>
            </div>



            <div className="row">
                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px", paddingRight: 0
                }}>

                    <div className={classesAutocomplete.root}>
                        <TextField
                            label='Billing Address 1'
                            required={true}
                            id='Billing Address 1'
                            value={paymentInfo?.address_line_one || ''}
                            onChange={(event) => updateValue('address_line_one', event.target.value)}
                            error={paymentInfo?.address_line_one && paymentInfo.address_line_one.trim().length === 0}
                            helperText={paymentInfo?.address_line_one && paymentInfo.address_line_one.trim().length === 0 ? "Billing address is required" : ""}
                        />
                    </div>
                </div>
                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px",
                }}>

                    <div className={classesAutocomplete.root}>
                        <TextField
                            label='Billing Address 2'
                            id='Billing Address 2'
                            value={paymentInfo?.address_line_two || ''}
                            onChange={(event) => updateValue('address_line_two', event.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="row">
                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px", paddingRight: 0
                }}>

                    <FormControl required className={durationClass.formControl} style={{ width: '100%' }}>
                        <InputLabel htmlFor="Country">
                            Country
                        </InputLabel>
                        <Select
                            className={classesAutocomplete.root}
                            required={true}
                            value={paymentInfo?.country_code || ''}
                            onChange={(event) => {
                                const rawValue = event.target.value ?? "";
                                updateValue("country_code", rawValue);
                                try {
                                    const country = JSON.parse(rawValue);
                                    if (country) {
                                        updateValue("country_code_formatted", country.code);
                                        setStates(country.province_codes);
                                    }
                                } catch {
                                    // ignore invalid JSON or handle error if needed
                                }
                            }}
                            inputProps={{
                                name: 'Country',
                                id: 'Country',
                            }}
                        >
                            <MenuItem value="">
                                <em>{` `}</em>
                            </MenuItem>
                            {countriesList.map((val, idx) => (
                                <MenuItem
                                    key={idx}
                                    value={JSON.stringify(val)}
                                    style={{ paddingTop: 8, paddingBottom: 8 }} // Add vertical spacing
                                >
                                    {val.name}
                                </MenuItem>
                            ))}


                        </Select>
                    </FormControl>
                </div>
                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px",
                }}>
                    <FormControl className={durationClass.formControl} style={{ width: '100%' }}>
                        <InputLabel htmlFor="State">
                            State/Province
                        </InputLabel>
                        <Select
                            className={classesAutocomplete.root}
                            value={paymentInfo?.address_state_code || ''}
                            onChange={(event) => updateValue('address_state_code', event.target.value)}
                            inputProps={{
                                name: 'state',
                                id: 'state',
                            }}
                        >

                            {stateList && Object.keys(stateList).map((keyName, idx) => (
                                <MenuItem
                                    key={idx}
                                    value={stateList[keyName]}
                                    style={{ paddingTop: 8, paddingBottom: 8 }} // Add vertical spacing
                                >
                                    {keyName}
                                </MenuItem>
                            ))}


                        </Select>
                    </FormControl>
                </div>
            </div>


            <div className="row">
                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px", paddingRight: 0
                }}>

                    <div className={classesAutocomplete.root}>
                        <TextField
                            label='City'
                            required={true}
                            id='City'
                            value={paymentInfo?.address_city || ''}
                            onChange={(event) => updateValue('address_city', event.target.value)}
                            error={paymentInfo?.address_city && paymentInfo.address_city.trim().length === 0}
                            helperText={paymentInfo?.address_city && paymentInfo.address_city.trim().length === 0 ? "City is required" : ""}
                        />
                    </div>
                </div>
                <div className={is_mobile ? 'col-12' : 'col-6'} style={{
                    marginTop: "20px",
                }}>

                    <div className={classesAutocomplete.root}>
                        <TextField
                            label='Postal Code'
                            required={false}
                            id='Postal Code'
                            error={paymentInfo?.address_postal_code?.length > 0 ? !validPostal : false}
                            helperText={!validPostal && paymentInfo?.address_postal_code?.length > 0 ? "Please enter a valid postal code" : ""}
                            value={paymentInfo?.address_postal_code || ''}
                            onChange={(event) => updateValue('address_postal_code', event.target.value?.toUpperCase())}
                        />
                    </div>
                </div>
            </div>

            {/* Form validation summary */}
            {!isFormValid() && (
                <div className="row">
                    <div className="col-12" style={{
                        marginTop: "20px",
                        padding: "15px",
                        backgroundColor: "#fff3cd",
                        border: "1px solid #ffeaa7",
                        borderRadius: "4px",
                        color: "#856404"
                    }}>
                        <strong>Please complete all required fields:</strong>
                        <ul style={{ margin: "10px 0 0 20px", padding: 0 }}>
                            {!getFieldValidationStatus('card_holder') && <li>Cardholder name</li>}
                            {!getFieldValidationStatus('card_number') && <li>Valid credit/debit card number</li>}
                            {!getFieldValidationStatus('card_type') && <li>Card type</li>}
                            {!getFieldValidationStatus('cvc_code') && <li>Security code (CVV)</li>}
                            {!getFieldValidationStatus('cc_exp_mo') && <li>Expiration month</li>}
                            {!getFieldValidationStatus('cc_exp_yr') && <li>Expiration year</li>}
                            {!getFieldValidationStatus('address_line_one') && <li>Billing address</li>}
                            {!getFieldValidationStatus('country_code') && <li>Country</li>}
                            {!getFieldValidationStatus('address_city') && <li>City</li>}
                            {!getFieldValidationStatus('address_postal_code') && <li>Valid postal code</li>}
                        </ul>
                    </div>
                </div>
            )}

        </div>
    )
}